import { swatchStyle, itemStyle, labelStyle, MAX_WIDTH } from './BreakdownLegend';

// Non-interactive legend: same swatch/label styling as the real BreakdownLegend, minus the checkbox
// behaviour. The 'legend-item' class alone (without the 'legend-selected' modifier that draws the
// checkmark via ::after) gives the identical bordered swatch shape with no checkmark - there's no
// "deselected" state to dim here, this is always a full, read-only snapshot of every series, so the
// swatch fill is overridden to solid colour rather than the interactive legend's 20%-tint fill. Used
// wherever the chart is read-only rather than something the viewer can toggle - the download modal's
// exported image, and a report's preview/shared view of the EngagementStatsWidget.
const PlainBreakdownLegend = ({ items }) => {
  if (!items?.length) return null;

  return (
    <ul className='d-flex align-items-center mb-5 pl-0' style={{ maxWidth: MAX_WIDTH, flexWrap: 'wrap', fontSize: '16px' }}>
      {items.map((item) => (
        <li key={item.bucket} style={{ ...itemStyle, cursor: 'default' }}>
          <span
            className='legend-item'
            style={{ ...swatchStyle(item.colour), backgroundColor: `rgb(${item.colour})`, marginTop: 0 }}
          />
          <p style={labelStyle}>{item.label}</p>
        </li>
      ))}
    </ul>
  );
};

export default PlainBreakdownLegend;
